<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '费用申请明细'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData">
        <section slot="order" slot-scope="prop">
          <ChooseOrder
            ref="order"
            :otherSearchData="{
              ...otherDialogData,
              orgId,
            }"
            :isRadio="true"
            :disabled="(otherDialogData.plateNumber && otherDialogData.carDriverMan) ? false : true"
            :handleParamsData="handleParamsData"
            placeholder="需先选择车牌号码和司机姓名"
            v-model="prop.form.order"
            @show="chooseOrderShow"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  queryVehicleExpenseTypes,
} from 'api/cost';
import ChooseOrder from 'components/choose/order';
export default {
  components: {
    ChooseOrder,
  },
  props: {
    orgId: {
      type: Number,
    },
    otherDialogData: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      originData: {},
      formData: {
        costTypeOptions: [],
        form: [
          {
            label: '费用类型',
            value: 'costType',
            type: 'select',
            placeholder: '请选择费用类型',
            onChange: () => {
              this.handleCostTypeChange();
            },
            hide: false,
          },
          {
            label: '费用类型',
            value: 'costTypeName',
            type: 'input',
            hide: true,
            disabled: true,
          },
          {
            label: '订单号码',
            value: 'order',
            slot: true,
            default: {},
          },
          {
            label: '费用日期',
            value: 'feeAscriptionDate',
            type: 'date',
            default: '',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '费用金额',
            value: 'payAmt',
            type: 'input',
            placeholder: '费用金额',
            unit: '元',
          },
          {
            label: '加油升数',
            value: 'oilLitre',
            type: 'input',
            default: '',
            placeholder: '请输入加油升数',
            hide: true,
          },
          {
            label: '费用说明',
            value: 'payRemark',
            type: 'input',
            default: '',
            placeholder: '请输入费用说明',
          },
          {
            label: '上传附件',
            value: 'detailPic',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: { // 表单验证规则
          costType: [
            { required: true, message: '请选择费用类型', trigger: 'change' },
          ],
          order: [
            { required: true, message: '请选择订单', trigger: 'change' },
            {
              validator: (rule, value, callback) => this.checkObjEmpty(rule, value, callback, '请选择订单'),
              trigger: 'blur',
            },
          ],
          feeAscriptionDate: [
            { required: true, message: '请输入费用日期', trigger: 'change' },
          ],
          payAmt: [
            { required: true, message: '请输入费用金额', trigger: 'change' },
          ],
        },
      },
    };
  },
  methods: {
    // 显示订单查找的弹窗后，需要强制用户只能选择指定搜索条件筛选出来的结果
    chooseOrderShow () {
      this.$refs.order.setOrderFormAttrVal('disabled', true, ['carDriverMan', 'plateNumber']);
    },
    handleCarChange (data) { // 车辆选择时
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: false,
        names: ['order'],
      });
      const car = this.$refs.customForm.getVal('car') || {};
      this.$refs.customForm.setVal('licenceTypeName', car.licenceTypeName);
    },

    handleCostTypeChange (clear) {
      const costType = this.$refs.customForm.getVal('costType');
      if (costType) {
        let costTypeName = '';
        for (let item of this.formData.costTypeOptions) {
          if (Number(item.value) === Number(costType)) {
            costTypeName = item.label;
          }
        }
        if (costTypeName) {
          this.$refs.customForm.setVal('costTypeName', costTypeName);
        }
        // 只有加油费的时候才显示加油升数
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: Number(costType) !== 3001,
          names: ['oilLitre'],
        });
      }
      if (clear) {
        this.$refs.customForm.setVal('costTypeName', '');
      }
    },

    handleParamsData (searchBoxData) {
      if (searchBoxData) {
        searchBoxData.filtrationExpense = -1;
        if (searchBoxData.Time && searchBoxData.Time.length) {
          searchBoxData.startDependTime = this.formatDate(searchBoxData.Time[0], 1);
          searchBoxData.endDependTime = this.formatDate(searchBoxData.Time[1], 1);
        }
        delete searchBoxData.Time;
      }
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(async () => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          item.order = {
            orderId: item.orderId,
            plateNumber: item.plateNumber,
          };
          item.costType = `${item.costType}`;
          item.car = {
            plateNumber: item.plateNumber,
            licenceType: item.licenceType,
            licenceTypeName: item.licenceTypeName,
          };
          this.$refs.customForm.setVal(item);
          this.handleCarChange(false);
          this.handleCostTypeChange();
          console.log('item', this.$refs.customForm.getVal('order'));
        } else { // 新增
          this.type = 'add';
          this.handleCostTypeChange(true);
        }
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      form.orderId = `${form.order.orderId}`;
      form.plateNumber = form.order.plateNumber;

      form.feeAscriptionDate = this.formatDate(form.feeAscriptionDate);
      // 后端设置这个参数是必填，所以如果不填写的话，默认填写一个 0
      form.oilLitre = form.oilLitre || '0';
      console.log('form', form);
      delete form.order;
      delete form.car;

      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
    async getList () {
      const vehicleFeeType = this.$route.query.vehicleFeeType;
      this.formData.costTypeOptions = await queryVehicleExpenseTypes({
        vehicleFeeType,
      });
    },
  },
  async mounted () {
    this.getList();
  },
};
</script>

<style>
</style>
